import { useEffect, useState } from "react";

import { NavLink, useHistory } from "react-router-dom";
import { appInsights } from "../../config/appInsights";
import useAllCompanyWallets from "../../custom-hooks/useAllCompanyWallets";
import { Loader } from "../../UI/Loaders/Loaders";
import Paginator from "../Pagination/Pagination.component";
import { TCompanyWalletParams } from "./types";

interface ICompanyWallets {
  id: number;
  accountName: string;
  accountNumber: string;
  bankName: string;
  consumerType: string;
  currency: string;
  walletId: string;
  walletProvider: string;
  walletProviderId: number;
}

const CompanyWallets = () => {
  const [searchQuery, setSearchQuery] = useState<TCompanyWalletParams>({
    ConsumerType: "COMPANY",
    Page: 1,
    PageSize: 10,
  });

  const history = useHistory();

  const {
    data: companyWallets,
    status,
    error,
  } = useAllCompanyWallets(searchQuery);

  useEffect(() => {
    appInsights.trackPageView({
      name: "Company Wallets - (CompanyWallets.jsx)",
      isLoggedIn: true,
    });
  }, []);

  let RenderedComponent = null;
  if (!companyWallets && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Default Wallet
            Provider
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered="true" text="Loading wallet providers..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              wallet providers, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (companyWallets &&
        companyWallets?.data.data &&
        companyWallets?.data.data.length === 0) ||
      (companyWallets?.data?.data && !companyWallets?.data.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no default
              wallet provider.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>S/N</th>
                  <th>Provider</th>
                  <th>Currency</th>
                  <th>Consumer Type</th>
                  <th>Bank Name</th>
                  <th>Account Name</th>
                  <th>Account Number</th>
                  <th>Wallet Id</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {companyWallets?.data?.data &&
                  companyWallets?.data?.data?.map(
                    (request: ICompanyWallets, _id: number) => {
                      return (
                        <tr key={_id}>
                          <td>{_id + 1}</td>
                          <td>{request.walletProvider}</td>
                          <td>{request.currency}</td>
                          <td>{request.consumerType}</td>
                          <td>{request.bankName}</td>
                          <td>{request.accountName}</td>
                          <td>{request.accountNumber}</td>
                          <td>{request.walletId}</td>
                          <td>
                            <span
                              className="details btn-manage zoom-element btn-slim"
                              onClick={() =>
                                history.push(
                                  `/company-wallets/transactions?accountNumber=${request?.accountNumber}&provider=${request.walletProvider}`
                                )
                              }
                            >
                              View Details
                            </span>
                          </td>
                        </tr>
                      );
                    }
                  )}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  return (
    <div className="datatable-wrapper">
      <div className="table-view animated speed-1x fadeInRight">
        <div className="row grid__padding animated fadeInRight">
          <div className="col-lg-12 col-md-12 col-sm-12 dashboard-title flex__row">
            <h3 className="m-l-1 relax-left">
              <aside className="rounder">
                <i className="fas fa-check-circle" />
              </aside>
              &nbsp; Company Wallets
            </h3>
            <div className="breadcrumb__location">
              <NavLink to="dashboard">
                <h3 className="breadcrumb__location__title ">Dashboard</h3>
              </NavLink>
              <span className="breadcrumb__location__icon">
                <i className="fas fa-angle-double-right" />
              </span>
              <NavLink to="manage-approvals">
                <h3 className="breadcrumb__location__title">Company Wallets</h3>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="row m-x-1 m-t-md">
          <div className="table-view speed-1x animated fadeInRight">
            <div className="d-flex flex-row flex-wrap mb-4">
              <h3 className="page-title">Company Wallets </h3>
            </div>
            {RenderedComponent}
            <Paginator
              size={searchQuery.PageSize}
              page={searchQuery.Page}
              count={companyWallets?.data.totalCount}
              changeCurrentPage={(pageNumber: number) =>
                setSearchQuery((prev) => {
                  return {
                    ...prev,
                    Page: pageNumber,
                  };
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyWallets;
